/**
 * Stable ascending sort by `addedAt` (ISO timestamp strings).
 * Used for FIFO wait-list promotion and any wait-list ordering that must match client `MASScheduleModel` behavior.
 */
export function sortWaitListByAddedAt<T extends { addedAt?: string }>(list: T[]): T[] {
	return [...list].sort((a, b) => (a.addedAt ?? '').localeCompare(b.addedAt ?? ''));
}
